import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { useIsMobile, useResponsiveEffect } from '../../../../hooks';
import { RelatedSalon } from '../../../../modules/provider/Profile';
import {
  BodyText,
  HeaderText,
  Stack,
  Grid,
} from '../../../ui';
import { ICrossPromotedProvider, ProviderCard } from '../CrossPromotion';
import type { ISearchResult } from '../../../../modules/consumer/search/Search';

type RelatedNearbyProsProps = {
  proSuggestions: ICrossPromotedProvider[] | RelatedSalon[] | ISearchResult[];
  onSelectPro?: (provider: ICrossPromotedProvider) => void;
};

export const RelatedNearbyPros = ({
  proSuggestions,
  onSelectPro,
}: RelatedNearbyProsProps) => {
  const isMobile = useIsMobile();
  const is = useResponsiveEffect();

  return (
    <Stack
      space={0}
      testID="related-nearby-pros"
      paddingTop={16}
    >
      <HeaderText level={3} textAlign="center">
        Similar pros nearby
      </HeaderText>
      <BodyText
        color={colors.metal}
        textAlign="center"
      >
        97% of professionals on StyleSeat have 4.6 stars or higher
      </BodyText>
      {isMobile ? (
        <Stack paddingTop={8}>
          {proSuggestions.map(provider => (
            <Box padding={12} key={provider.provider_id.toString()}>
              <ProviderCard
                provider={provider}
                onClick={onSelectPro}
                appearance="large"
                utmSource="inactive_cross_promo"
                showProfession
                showLocation
                showService={false}
              />
            </Box>
          ))}
        </Stack>
      ) : (
        <Grid columns={is.desktopNarrow ? 2 : 3}>
          {proSuggestions.map(provider => (
            <Box padding={12} key={provider.provider_id.toString()}>
              <ProviderCard
                provider={provider}
                onClick={onSelectPro}
                appearance="large"
                utmSource="inactive_cross_promo"
                showProfession
                showLocation
                showService={false}
              />
            </Box>
          ))}
        </Grid>
      )}
    </Stack>
  );
};
